import React from "react";
import { Box } from "reactjs-admin-lte";
import $ from "jquery";
import "fullcalendar";
import "jquery-ui/ui/core";
import "jquery-ui/ui/widgets/draggable";
import ConfirmPopup from "../../component/element/ConfirmPopup";
import { Checkbox } from "react-icheck";
// import FullCalendar from 'fullcalendar-reactwrapper';
import "fullcalendar-reactwrapper/dist/css/fullcalendar.min.css";
import CalendarStore from "stores/CalendarStore";
import "./Calendar.css";
const API_MAIN = CalendarStore.getBaseUrl();

class CalendarNotificationInSystem extends React.Component {
  constructor(...props) {
    super(...props);
    this.$ = $.noConflict();
    this.state = {
      confirmDelivering: false,
      confirmMsg: "ต้องการเปลี่ยนแปลงวันส่งมอบรถ ?",
      settings: {
        id: "calendar",
        header: {
          left: "prev,next today",
          center: "title",
          right: "basicDay,basicWeek,month,",
        },
        views: {
          week: {
            // name of view
            columnFormat: "ddd D",
            // other view-specific options here
          },
        },
        minTime: "8:00:00",
        maxTime: "18:00:00",
        allDayDefault: true,
        eventSources: [
          // your event source
          {
            url: API_MAIN + "/calendar/advancebooking_events",
            data: {
              start: "2022-03-28",
              end: "2022-05-08",
            },
            error: function () {
              alert("there was an error while fetching events!");
            },
            xhrFields: {
              withCredentials: true,
            },
          },

          // any other sources...
        ],
        //Random default events
        locale: "th",
        buttonText: {
          today: "วันนี้",
          month: "เดือน",
          week: "สัปดาห์",
          day: "วัน",
          list: "รายการ",
        },
        height: 900,
        editable: true,
        weekNumbers: false,
        eventLimit: true, //Allow more link
        droppable: true, // this allows things to be dropped onto the calendar !!!
        hiddenDays: [0],
        drop: function (date, allDay) {
          // is the "remove after drop" checkbox checked?
          if ($("#drop-remove").is(":checked")) {
            // if so, remove the element from the "Draggable Events" list
            $(this).remove();
          }
        },
        /**
         * Calendar Event
         */
        dayClick: (date, jsEvent, view) => {
          const { calendar } = view;
          calendar.changeView("basicDay");
          calendar.gotoDate(date);
          console.log("Clicked on: " + date.format());
        },
        eventDrop: (event, delta, revertFunc) => {
          console.log(
            event.title +
              " was dropped on " +
              event.start.format() +
              " wo:" +
              event.workno
          );
          if (event.workno != "") {
            this.onCancelUpdate = () => {
              revertFunc();
              this.setState({ confirmDelivering: false });
            };

            this.onConfirmUpdate = () => {
              console.log(
                "update delivering date to ",
                event.workno,
                event.start.format()
              );
              this.updateDeliveryDate(
                event.bf_notification_id,
                event.start.format()
              );
            };
            const confirmMsg =
              "ต้องการเปลี่ยนแปลงการแจ้งเตือนในระบบ ไปยังวันที่ " +
              event.start.format() +
              " ?";
            this.setState({ confirmDelivering: true, confirmMsg: confirmMsg });
          } else {
            revertFunc();
          }
        },

        eventClick: (calEvent, jsEvent, view) => {
          const data = {
            event: "Event: " + calEvent.title + ",wo:" + calEvent.workno,
            coordinates: "Coordinates: " + jsEvent.pageX + "," + jsEvent.pageY,
            view: "View: " + view.name,
          };

          //window.alert(JSON.stringify(data));

          // change the border color just for fun
          //$(this).css('border-color', 'red');
          if (calEvent.workno != "" && window.show_work_doc !== undefined)
            window.show_work_doc(calEvent.workno);
        },
      },
    };
  }

  updateDeliveryDate(bf_notification_id, date) {
    const data = { newdate: date };
    CalendarStore.updateNotificationNoticeDate(
      "in_system",
      bf_notification_id,
      data,
      () => {
        this.setState({ confirmDelivering: false });
      },
      () => {}
    );
    // $.ajax({
    //   method: 'post',
    //   url, data,
    //   xhrFields: {
    //     withCredentials: true,
    //   },
    // }).done((data) => {
    //   console.log('Data Loaded: ' + data);
    // }).fail((error) => {
    //   console.log(error.responseText);
    // }).always(() => {
    //   console.log('finished');
    //   this.setState({confirmDelivering: false});
    // });
  }

  componentDidMount() {
    // this.loadData()
  }

  loadData() {
    this.$("#calendar-car-advancebooking").fullCalendar(this.state.settings);
    // const jq = this.$;
    $(".external-event").each(function () {
      $(this).data("event", {
        backgroundColor: $(this).css("background-color"),
        borderColor: $(this).css("border-color"),
        title: $.trim($(this).text()), // use the element's text as the event title
        stick: true, // maintain when user navigates (see docs on the renderEvent method)
      });

      $(this).draggable({
        zIndex: 1070,
        revert: true, // will cause the event to go back to its
        revertDuration: 0, //  original position after the drag
      });
    });
  }

  onHideDayChange() {
    let { settings } = this.state;
    if (settings.hiddenDays.length > 0) {
      settings.hiddenDays = [];
    } else {
      settings.hiddenDays.push(0);
    }
    this.setState({ settings: settings });
    $("#calendar-car-advancebooking").fullCalendar(
      "option",
      "hiddenDays",
      settings.hiddenDays
    );
  }

  render() {
    const { state } = this;
    const { confirmDelivering, confirmMsg, settings } = state;

    return (
      <div>
        <Box>
          <Box.Body>
            <div>
              <Checkbox
                onChange={this.onHideDayChange.bind(this)}
                checked={settings.hiddenDays.length > 0 ? false : true}
                checkboxClass="icheckbox_square-blue"
                increaseArea="20%"
                label=" แสดงวันอาทิตย์"
              ></Checkbox>
            </div>
            <div id={"calendar-car-advancebooking"}></div>
            {/*<FullCalendar*/}
            {/*{...this.state.settings}*/}
            {/*/>*/}
          </Box.Body>
          {/* <Box.Footer>
            <div className="col-md-12">
              สถานะการแจ้งเตือน
              <div id="external-events" className="row">
                <div className="col-md-4 external-event bg-gray">
                  ยังไม่ได้ดำเนินการ
                </div>
                <div className="col-md-4 external-event bg-green">
                  ดำเนินการแล้ว
                </div>
                <div className="col-md-4 external-event bg-red">
                  ยกเลิกดำเนินการ
                </div>
              </div>
            </div>
          </Box.Footer> */}
        </Box>
        <ConfirmPopup
          show={confirmDelivering}
          title="ยืนยัน"
          confirmTitle="ตกลง"
          cancelTitle="ยกเลิก"
          message={confirmMsg}
          onConfirm={this.onConfirmUpdate}
          onHide={this.onCancelUpdate}
        />
      </div>
    );
  }
}

export default CalendarNotificationInSystem;



// WEBPACK FOOTER //
// ./src/view/calendar/CalendarCarAdvanceBooking.js